import { render, staticRenderFns } from "./InputRadioButton.vue?vue&type=template&id=43c607b2&scoped=true"
import script from "./InputRadioButton.vue?vue&type=script&lang=js"
export * from "./InputRadioButton.vue?vue&type=script&lang=js"
import style0 from "./InputRadioButton.vue?vue&type=style&index=0&id=43c607b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c607b2",
  null
  
)

export default component.exports